/**
 * QR コード URL から hash パラメータを抽出する。
 * URL 形式: https://.../qr/?hash=<hash_value>
 * 取得できない場合は null を返す。
 */
export const extractQrHash = (qrText: string): string | null => {
  try {
    const url = new URL(qrText)
    const hash = url.searchParams.get('hash')
    return hash !== null && hash.length > 0 ? hash : null
  } catch {
    return null
  }
}

/**
 * 数字のみで構成された文字列を正の安全な整数としてパースする。
 * 数字以外を含む・0 以下・`Number.MAX_SAFE_INTEGER` 超（桁数が極端に長く `Infinity` になる場合を含む）は null を返す。
 */
export const parsePositiveSafeInt = (value: string): number | null => {
  // 数字のみで構成されていることを確認してからパース（"9507abc" / "1e3" / "0x1f" 等の誤パース防止）
  if (!/^\d+$/.test(value)) return null
  const num = Number(value)
  return Number.isSafeInteger(num) && num > 0 ? num : null
}

/**
 * QR ハッシュ文字列からスポット ID をパースする。
 * ハッシュ形式: `{stampCode}-{spotId}` （例: `eb102ec9077bc24927a10f31f1d8bae1-9507`）
 * `stampCode` はスタンプ単位の共有コード（管理画面入力または生成値）で、スポットごとの署名ではない。
 * パースできない場合は null を返す。
 */
export const parseSpotIdFromHash = (hash: string): number | null => {
  const lastDash = hash.lastIndexOf('-')
  if (lastDash === -1) return null
  return parsePositiveSafeInt(hash.slice(lastDash + 1))
}
